// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__gilroyBold_329251', '__gilroyBold_Fallback_329251'","fontWeight":700},"className":"__className_329251","variable":"__variable_329251"};